export const idx_data_span_measurement = [];

let order = 0;
idx_data_span_measurement.push({
  fraction: '---',
  decimal: 0,
  order_idx: -1,
});

for (let i = 1; i < 7; i++) {
  if (i >= 2) {
    idx_data_span_measurement.push({
      fraction: i + '',
      decimal: i,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 1/16',
      decimal: i + 1 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 1/8',
      decimal: i + 1 / 8,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 3/16',
      decimal: i + 3 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 1/4',
      decimal: i + 1 / 4,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 5/16',
      decimal: i + 5 / 16,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 3/8',
      decimal: i + 3 / 8,
      order_idx: order,
    });
    order++;

    idx_data_span_measurement.push({
      fraction: i + ' 7/16',
      decimal: i + 7 / 16,
      order_idx: order,
    });
    order++;
  }

  idx_data_span_measurement.push({
    fraction: i + ' 1/2',
    decimal: i + 1 / 2,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 9/16',
    decimal: i + 9 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 5/8',
    decimal: i + 5 / 8,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 11/16',
    decimal: i + 11 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 3/4',
    decimal: i + 3 / 4,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 13/16',
    decimal: i + 13 / 16,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 7/8',
    decimal: i + 7 / 8,
    order_idx: order,
  });
  order++;

  idx_data_span_measurement.push({
    fraction: i + ' 15/16',
    decimal: i + 15 / 16,
    order_idx: order,
  });
  order++;
}

idx_data_span_measurement.push({
  fraction: '7',
  decimal: 7,
  order_idx: order,
});
